/* eslint-disable */
import Swiper from 'swiper/swiper-bundle';

Drupal.behaviors.carouselFull = {
  attach(context) {
    // Locate the elements to apply swiper to.
    const carouselFull = context.getElementsByClassName('swiperFull');

    if (carouselFull) {
      // Apply swiper function.
      const swiper = new Swiper('.swiperFull', {
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      swiper.init();
    }
  },
};
